import React from "react";
import PropTypes from "prop-types";
import { Container } from "reactstrap";
import { Route } from "react-router-dom";
import WithAuthUncheck from "../WithAuthUncheck/index";
import { compose, setDisplayName, lifecycle, withHandlers } from "recompose";
import { actions } from "../../modules/auth";
import { connect } from "react-redux";
import Card from "../../components/Card";

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
};

const mapStateToProps = state => ({});

const mapActionCreators = {
  resetState: actions.resetState
};

const withResetAuthState = compose(
  connect(
    mapStateToProps,
    mapActionCreators
  ),
  withHandlers({
    cleanState: ({ resetState }) => () => {
      resetState();
    }
  }),
  lifecycle({
    componentDidMount() {
      window.addEventListener("beforeunload", this.props.cleanState);
    },
    componentWillUnmount() {
      const { cleanState } = this.props;
      //cleanState();
      window.removeEventListener("beforeunload", cleanState);
    }
  })
);

const Auth = ({ component, ...rest }) => {
  const Component = withResetAuthState(component);
  return (
    <Route
      {...rest}
      render={matchProps => (
        <div className="login-hero">
          <Container>
            <div className="row align-items-md-center my-4">
              <div className="col-md-6 col-sm-12">
                <Card
                  title={<h4 className="login-title">DEALER SERVICE PRO</h4>}
                  center="true"
                  content={
                    <div className="content">
                      <Component {...matchProps} />
                    </div>
                  }
                />
              </div>
              <div className="col-md-6 col-sm-12 mt-4 mt-sm-0">
                <h1 className="catchword">WELCOME TO DEALER SERVICE PRO</h1>
              </div>
            </div>
          </Container>
        </div>
      )}
    />
  );
};

Auth.propTypes = propTypes;

export default compose(
  setDisplayName("Auth"),
  WithAuthUncheck
)(Auth);
